export type Faq = { q: string; a: string };

export const faqs: Faq[] = [
  {
    q: '「反差现场」主要收录哪几类内容？',
    a: '本站目前分为四个栏目：直播翻车现场、台下偶遇实录、粉丝爆料、私下被拍。所有内容都围绕"镜头前的公开状态"与"镜头外的真实状态"之间的差别展开，尽量保留完整的原始语境。',
  },
  {
    q: '这些内容会不会涉及侵犯隐私？',
    a: '我们的原则是只呈现与公开言行不一致相关的信息。私人住所、联系方式、家庭成员、未成年人等内容一律不收录，也不接受跟踪、蹲守类投稿。超出这条线的素材，无论多"劲爆"都不会出现在站内。',
  },
  {
    q: '为什么有的反差看起来是正面评价？',
    a: '反差本身是中性的。有人台上温和、台下急躁，也有人镜头前高冷、镜头后热心。我们更愿意完整呈现两种状态，让读者自己判断，而不是提前给出"好人"或"坏人"的标签。',
  },
  {
    q: '内容里的时间、账号信息来自哪里？',
    a: '公开直播回放、公开社交内容、以及当事人或目击者的投稿自述。涉及具体账号时，我们会做必要的模糊化处理，重点放在行为与场景本身，而不是指向某个人。',
  },
  {
    q: '普通读者可以投稿吗？',
    a: '可以。如果你在现场目睹过与公开人设明显不符的场景，可以通过"关于我们"页面的联系入口提交描述。我们更看重时间、地点、情境的完整性，而不是情绪化的判断。',
  },
  {
    q: '更新频率大概是怎样的？',
    a: '站内内容按周更新，每周整理一批新的现场素材，同时维护已有的热门档案。四大栏目会保持相对均衡的更新节奏，避免单一话题过度堆积。',
  },
];